/* eslint-disable no-undef */
const mapStyle = [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          weight: '2.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#9c9c9c',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#eeeeee',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7b7b7b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#46bcec',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c8d7d4',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#070707',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
  ];

const selectors = {
    map: '[data-js-map]',
    infoWindows: '[data-info-window]',
    searchStores: '[data-search-stores]',
    selectState: '[data-filter-stores]',
    noStoresMessage: '[data-no-stores-message]',
};

  const classes = {
    activeInfoWindow: 'DG-info-window--active',
    activeNoStoresMessage: 'DG-no-stores-message--active',
};

const australianStates = {
  NSW: { name: 'New South Wales', lat: -33.8688, lng: 151.2093 },
  VIC: { name: 'Victoria', lat: -37.8136, lng: 144.9631 },
  QLD: { name: 'Queensland', lat: -27.4698, lng: 153.0251 },
  WA: { name: 'Western Australia', lat: -31.9505, lng: 115.8605 },
  SA: { name: 'South Australia', lat: -34.9285, lng: 138.6007 },
  TAS: { name: 'Tasmania', lat: -42.8821, lng: 147.3272 },
  ACT: { name: 'Australian Capital Territory', lat: -35.2809, lng: 149.1300 },
  NT: { name: 'Northern Territory', lat: -12.4634, lng: 130.8456 }
};

  function parseCoordinates(coordinates) {
    if (!coordinates || typeof coordinates !== 'string') return;

    const parts = coordinates.split(',');

    const latitude = parseFloat(parts[0]);
    const longitude = parseFloat(parts[1]);

    if (isNaN(latitude) || isNaN(longitude)) {
      window.console.error('Invalid latitude or longitude');
      return null;
    }

    return {latitude, longitude};
  }

  function filterInfoWindowsByState(infoWindows, stateCode) {
    let availableStoresCount = 0;
    const noStoresMessage = document.querySelector(selectors.noStoresMessage);
    infoWindows.forEach((infoWindow) => {
      if (stateCode === 'All' || infoWindow.dataset?.state === stateCode) {
        infoWindow.classList.add(classes.activeInfoWindow);
        availableStoresCount++;
      } else {
        infoWindow.classList.remove(classes.activeInfoWindow);
      }
    });

    if (availableStoresCount === 0 && noStoresMessage) {
      noStoresMessage.classList.add(classes.activeNoStoresMessage);
    } else {
      noStoresMessage.classList.remove(classes.activeNoStoresMessage);
    }
  }

  function getVisibleMarkerIds(infoWindows, stateCode) {
    const ids = [];
    infoWindows.forEach((iw) => {
      if (stateCode === 'All' || iw.dataset?.state === stateCode) {
        ids.push(iw.dataset.id);
      }
    });
    return ids;
  }

  function moveMapToState(stateCode, map, infoWindows, markers) {
    filterInfoWindowsByState(infoWindows, stateCode);

    if (stateCode === 'All') {
      map.setCenter({ lat: -25.2744, lng: 133.7751 });
      map.setZoom(4);
      return;
    }

    const visibleIds = getVisibleMarkerIds(infoWindows, stateCode);
    const stateMarkers = markers.filter(m => visibleIds.includes(m.id));

    if (stateMarkers.length === 1) {
      map.setCenter(stateMarkers[0].getPosition());
      map.setZoom(10);
    } else if (stateMarkers.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      stateMarkers.forEach(m => bounds.extend(m.getPosition()));
      map.fitBounds(bounds, 50);
    } else {
      const state = australianStates[stateCode];
      if (state) {
        map.setCenter({ lat: state.lat, lng: state.lng });
        map.setZoom(6);
      }
    }
  }

  const initFilters = (map, infoWindows, markers) => {
    const searchStores = document.querySelector(selectors.searchStores);
    const selectState = document.querySelector(selectors.selectState);
    if(!searchStores && !selectState) return;

    selectState.addEventListener('change', (e) => {
      const stateCode = e.target.value;
      moveMapToState(stateCode, map, infoWindows, markers);
    });

    searchStores.addEventListener('keyup', (e) => {
      const searchValue = e.target.value.toLowerCase();
      let availableStoresCount = 0;
      const noStoresMessage = document.querySelector(selectors.noStoresMessage);

      infoWindows.forEach((infoWindow) => {
        const storeId = infoWindow.dataset.id.toLowerCase();
        const storeAddress = infoWindow.dataset.address.toLowerCase();
        if (storeId.includes(searchValue) || storeAddress.includes(searchValue)) {
          infoWindow.classList.add(classes.activeInfoWindow);
          availableStoresCount++;
        } else {
          infoWindow.classList.remove(classes.activeInfoWindow);
        }
      });

      if (availableStoresCount === 0) {
        noStoresMessage.classList.add(classes.activeNoStoresMessage);
      } else {
        noStoresMessage.classList.remove(classes.activeNoStoresMessage);
      }
    });
  }

  const initMap = (mapElement, markers) => {
    if(!mapElement) return;
    const desktopQuery = window.matchMedia(`(min-width: 1000px)`);
    const markersData = mapElement.dataset.markers;
    const mapSettings = mapElement.dataset.settings;
    const infoWindows = document.querySelectorAll(selectors.infoWindows);

    if (!markersData || !mapSettings) return;

    const markersJson = JSON.parse(markersData);
    const mapSettingsJson = JSON.parse(mapSettings);
    const customMapMarkerIcon = mapElement.dataset?.markerImageUrl;

    const coordinates = {
      desktop: parseCoordinates(mapSettingsJson?.map_start_position),
      mobile: parseCoordinates(mapSettingsJson?.map_start_position_mobile),
    };

    const zoom = {
      desktop: mapSettingsJson?.map_zoom || 11,
      mobile: mapSettingsJson?.map_zoom_mobile || 11,
    };

    const view = desktopQuery.matches ? 'desktop' : 'mobile';
    const longitude = coordinates[view]?.longitude;
    const latitude = coordinates[view]?.latitude;

    const mapOptions = {
      zoom: zoom[view],
      center: new google.maps.LatLng(latitude, longitude),
      styles: mapStyle,
      streetViewControl: false,
    };

    let map = new google.maps.Map(mapElement, mapOptions);

    markersJson.forEach(function (markerData) {
      const coordinates = markerData.coordinates.split(',');
      const latLng = new google.maps.LatLng(parseFloat(coordinates[0]), parseFloat(coordinates[1]));

      const customMarkerIcon = {
        url: customMapMarkerIcon ?? null,
        scaledSize: new google.maps.Size(50, 50),
      };

      const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: markerData.title,
        icon: customMarkerIcon ?? null,
      });

      marker.id = markerData.id;
      marker.stateCode = markerData.state;
      markers.push(marker);

      marker.addListener('click', function () {
        infoWindows.forEach((infoWindow) => {
          if (marker.id === infoWindow.dataset.id) {
            infoWindow.classList.add(classes.activeInfoWindow);
          } else {
            infoWindow.classList.remove(classes.activeInfoWindow);
          }
        });
      });
    });

    return map;
  }

const initStoreLocator = () => {
  const mapElement = document.querySelector(selectors.map);
  const infoWindows = document.querySelectorAll(selectors.infoWindows);
  let markers = [];
  let map = initMap(mapElement, markers);
  initFilters(map, infoWindows, markers);
};

document.addEventListener('DOMContentLoaded', () => {
  initStoreLocator();
});

